import { ReportsActions, ReportsActionTypes } from '../actions/reports.actions';

export interface ReportsState {
  loading: boolean;
  reportTitle: string;
  isReportSuccessful: boolean;
  reportSuccessfulText: string;
}

export const initialState: ReportsState = {
  loading: false,
  reportTitle: '',
  isReportSuccessful: false,
  reportSuccessfulText: '',
};

export function reportsReducer(state = initialState, action: ReportsActions): ReportsState {
  switch (action.type) {
    case ReportsActionTypes.RUN_REPORT_DATA_ERROR:
      return {
        ...state,
        loading: false
      };
    case ReportsActionTypes.RUN_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        isReportSuccessful: true,
        reportSuccessfulText: 'Success! The report has been generated and downloaded.'
      };
    case ReportsActionTypes.CREATE_REPORT_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        isReportSuccessful: true,
        reportSuccessfulText: `The report is currently running and will be in View Reports when available`
      };
    default:
      return state;
  }
}
